import { render } from "./ModalTitle.vue?vue&type=template&id=42325e0a&scoped=true"
import script from "./ModalTitle.vue?vue&type=script&lang=js"
export * from "./ModalTitle.vue?vue&type=script&lang=js"

import "./ModalTitle.vue?vue&type=style&index=0&id=42325e0a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-42325e0a"

export default script